import { render, staticRenderFns } from "./EventThemeItem.vue?vue&type=template&id=db136e18&scoped=true"
import script from "./EventThemeItem.vue?vue&type=script&lang=ts"
export * from "./EventThemeItem.vue?vue&type=script&lang=ts"
import style0 from "./EventThemeItem.vue?vue&type=style&index=0&id=db136e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db136e18",
  null
  
)

export default component.exports